import { Component } from '../core/component.js';
import { MapUtils } from '../../utility/map-utils.js';
import {
  cloneData,
  DataModelBuilder,
  isSameData,
  SerializationContext,
  SerializedData,
} from '../../models/dto/dto.js';
import { PaymentProtocolSettings } from '../../models/serializable/payment-protocol-settings.js';
import { LegacyPaymentSettingsComponent } from './legacy-payment-settings-component.js';
import { LegacyPaymentSettings } from '../../models/serializable/legacy-payment-settings.js';

export class PaymentProtocolComponent extends Component {
  static readonly TYPE_ID: string = '9e90d3e6111b4be6a63277e5c1cb6c2d';

  constructor(
      public readonly settings: PaymentProtocolSettings,
  ) {
    super();
  }

  get $typeId() {
    return PaymentProtocolComponent.TYPE_ID;
  }

  get $removable() {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PaymentProtocolComponent {
    return new PaymentProtocolComponent(
        context.fromData(MapUtils.get<SerializedData>(map, 'settings')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'settings': context.toData(this.settings),
    };
  }

  clone(): this {
    return new PaymentProtocolComponent(
        this.settings.clone(),
    ) as this;
  }

  copyWith({
    settings = cloneData(this.settings),
  }: {
    settings?: PaymentProtocolSettings,
  } = {}): this {
    return new PaymentProtocolComponent(settings) as this;
  }

  isSame(other: PaymentProtocolComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.settings, this.settings);
  }

  // eslint-disable-next-line valid-jsdoc
  /**
   * @deprecated Will be removed in the next deployment.
   */
  toLegacy(): LegacyPaymentSettingsComponent {
    return new LegacyPaymentSettingsComponent(
        LegacyPaymentSettings.create({
          paymentAccount: this.settings.standard.paymentAccount.clone(),
          paymentMethods: [...this.settings.standard.paymentMethods],
          allowLegalEntityInvoices: this.settings.standard.allowLegalEntityInvoices,
          allowOfflineOrderReceipts: this.settings.standard.allowOfflineOrderReceipts,
        }),
    );
  }
}

export class PaymentProtocolComponentBuilder extends DataModelBuilder<PaymentProtocolComponent> {
  build(context: SerializationContext, map: SerializedData): PaymentProtocolComponent {
    return PaymentProtocolComponent.fromMap(context, map);
  }
}
